import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const BINGO_GAMES = [
  { key: "bingo_10", label: "Bingo 5", url: process.env.REACT_APP_BINGO_10_URL || "http://localhost:8001", color: "#8b5cf6" },
  { key: "bingo_20", label: "Bingo 10", url: process.env.REACT_APP_BINGO_20_URL || "http://localhost:8002", color: "#3b82f6" },
  { key: "emoji_5",  label: "Emoji 5",  url: process.env.REACT_APP_BINGO_30_URL || "http://localhost:8003", color: "#10b981" },
  { key: "emoji_10", label: "Emoji 3", url: process.env.REACT_APP_BINGO_40_URL || "http://localhost:8004", color: "#f97316" },
];

const EMPTY = { daily: 0, weekly: 0, monthly: 0, total: 0, games_played: 0, label: "—" };

const S = {
  page: { padding: "0 0 80px 0", fontFamily: "system-ui, sans-serif", background: "#f5f5f5", minHeight: "100vh" },
  header: { background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "#fff", padding: "1rem 1.25rem", display: "flex", justifyContent: "space-between", alignItems: "center" },
  title: { margin: 0, fontSize: "1.1rem", fontWeight: 700 },
  back: { color: "#fff", textDecoration: "none", fontSize: "0.85rem", opacity: 0.9 },
  refreshBtn: { background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 8, padding: "0.3rem 0.75rem", cursor: "pointer", fontSize: "0.8rem", fontWeight: 600 },
  totalCards: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem", padding: "0.75rem 1rem" },
  totCard: (color) => ({ background: "#fff", borderRadius: 12, padding: "0.9rem 1rem", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", borderTop: `3px solid ${color}` }),
  totLabel: { fontSize: "0.65rem", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: "0.25rem" },
  totVal: (color) => ({ fontSize: "1.2rem", fontWeight: 800, color }),
  sectionTitle: { padding: "0 1rem 0.4rem", fontSize: "0.85rem", fontWeight: 700, color: "#374151", marginTop: "0.25rem" },
  table: { margin: "0 1rem", background: "#fff", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.07)" },
  th: { padding: "0.55rem 0.75rem", fontSize: "0.68rem", color: "#6b7280", fontWeight: 700, textTransform: "uppercase", background: "#f9fafb", textAlign: "right", borderBottom: "1px solid #f3f4f6" },
  thLeft: { padding: "0.55rem 0.75rem", fontSize: "0.68rem", color: "#6b7280", fontWeight: 700, textTransform: "uppercase", background: "#f9fafb", textAlign: "left", borderBottom: "1px solid #f3f4f6" },
  td: { padding: "0.6rem 0.75rem", fontSize: "0.82rem", color: "#374151", textAlign: "right", borderBottom: "1px solid #f9fafb" },
  tdLeft: { padding: "0.6rem 0.75rem", fontSize: "0.82rem", fontWeight: 700, textAlign: "left", borderBottom: "1px solid #f9fafb" },
  totalRow: { background: "#f0f0ff" },
};

function HouseManagement() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchAll = useCallback(async () => {
    const results = {};
    await Promise.all(
      BINGO_GAMES.map(async (g) => {
        try {
          const r = await axios.get(`${g.url}/api/admin/house-cut`, { timeout: 4000, headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } });
          results[g.key] = r.data;
        } catch {
          results[g.key] = { ...EMPTY, label: g.label };
        }
      })
    );
    setData(results);
    setLastUpdated(new Date());
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchAll();
    const iv = setInterval(fetchAll, 30000);
    return () => clearInterval(iv);
  }, [fetchAll]);

  const total = (key) => BINGO_GAMES.reduce((s, g) => s + ((data[g.key] || EMPTY)[key] || 0), 0);
  const totalDaily   = total("daily");
  const totalWeekly  = total("weekly");
  const totalMonthly = total("monthly");
  const totalAll     = total("total");

  return (
    <div style={S.page}>
      <header style={S.header}>
        <h1 style={S.title}>🏦 House Cut</h1>
        <div style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
          <button style={S.refreshBtn} onClick={fetchAll}>🔄 Refresh</button>
          <Link to="/dashboard" style={S.back}>← Back</Link>
        </div>
      </header>

      {lastUpdated && (
        <div style={{ textAlign: "right", fontSize: "0.65rem", color: "#9ca3af", padding: "0.4rem 1rem 0" }}>
          Updated: {lastUpdated.toLocaleTimeString()}
        </div>
      )}

      <div style={S.totalCards}>
        <div style={S.totCard("#667eea")}>
          <div style={S.totLabel}>Today</div>
          <div style={S.totVal("#667eea")}>{totalDaily} Birr</div>
        </div>
        <div style={S.totCard("#3b82f6")}>
          <div style={S.totLabel}>This Week</div>
          <div style={S.totVal("#3b82f6")}>{totalWeekly} Birr</div>
        </div>
        <div style={S.totCard("#10b981")}>
          <div style={S.totLabel}>This Month</div>
          <div style={S.totVal("#10b981")}>{totalMonthly} Birr</div>
        </div>
        <div style={S.totCard("#f97316")}>
          <div style={S.totLabel}>All Time</div>
          <div style={S.totVal("#f97316")}>{totalAll} Birr</div>
        </div>
      </div>

      <div style={S.sectionTitle}>Breakdown by Game</div>

      <div style={S.table}>
        {loading ? (
          <div style={{ padding: "1.5rem", textAlign: "center", color: "#9ca3af" }}>Loading...</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={S.thLeft}>Game</th>
                <th style={S.th}>Daily</th>
                <th style={S.th}>Weekly</th>
                <th style={S.th}>Monthly</th>
                <th style={S.th}>All Time</th>
                <th style={S.th}>Games</th>
              </tr>
            </thead>
            <tbody>
              {BINGO_GAMES.map((g) => {
                const d = data[g.key] || EMPTY;
                return (
                  <tr key={g.key}>
                    <td style={{ ...S.tdLeft, color: g.color }}>
                      <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: g.color, marginRight: 6 }} />
                      {g.label}
                    </td>
                    <td style={S.td}>{d.daily}</td>
                    <td style={S.td}>{d.weekly}</td>
                    <td style={S.td}>{d.monthly}</td>
                    <td style={{ ...S.td, fontWeight: 700 }}>{d.total}</td>
                    <td style={{ ...S.td, color: "#6b7280" }}>{d.games_played}</td>
                  </tr>
                );
              })}
              <tr style={S.totalRow}>
                <td style={{ ...S.tdLeft, color: "#667eea", fontWeight: 800 }}>TOTAL</td>
                <td style={{ ...S.td, fontWeight: 800, color: "#667eea" }}>{totalDaily}</td>
                <td style={{ ...S.td, fontWeight: 800, color: "#3b82f6" }}>{totalWeekly}</td>
                <td style={{ ...S.td, fontWeight: 800, color: "#10b981" }}>{totalMonthly}</td>
                <td style={{ ...S.td, fontWeight: 800, color: "#f97316" }}>{totalAll}</td>
                <td style={{ ...S.td, color: "#6b7280" }}>
                  {BINGO_GAMES.reduce((s, g) => s + ((data[g.key] || EMPTY).games_played || 0), 0)}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default HouseManagement;
